export default {"src":"/customer-services/_next/static/media/guaranteed.0194591c.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};